import { Text } from "@ttc3k/trekker";
import { Box, Flex, FlexProps } from "styled-system/jsx";
import { simpleFlagRecipe, StatusIndicatorVariants } from "./simpleFlag.recipe";

type SimpleFlagProps = {
  text: string;
  containerProps?: FlexProps;
} & StatusIndicatorVariants;

export const SimpleFlag = ({
  text,
  visual = "accent.purple",
  containerProps,
}: SimpleFlagProps) => {
  const { box, text: textStyle } = simpleFlagRecipe({ visual });

  return (
    <Flex
      gap={"200"}
      alignItems={"stretch"}
      justifyContent={"flex-start"}
      {...containerProps}
    >
      <Box className={box} />
      <Text visual={"smallMedium"} className={textStyle}>
        {text}
      </Text>
    </Flex>
  );
};
